import React from 'react'

import { cn } from '@/lib/utils'

import { StylesProps } from '../page-header.types'
import { bannerTextClasses } from '../page-header-utils'
import { HeaderBanner } from '../shared/header-banner'
import { HeaderDescription } from '../shared/header-description'
import { HeaderLogo } from '../shared/header-logo'
import { HeaderName } from '../shared/header-name'
import { HeaderSocialIcons } from '../shared/header-social-icons'

export const GeexResumePageHeader = ({
  page,
  hasBannerImage,
  bannerLuminance,
  forceMobile,
  ...props
}: StylesProps) => {
  const textClasses = bannerTextClasses(bannerLuminance)

  return (
    <div className={cn('relative', { 'lg:pt-fluid-10': !forceMobile })}>
      <HeaderBanner
        media={page?.bannerMedia}
        className={cn('absolute size-full', {
          'lg:rounded-t-page-widget': !forceMobile,
        })}
        style={{
          WebkitMaskImage: `linear-gradient(to bottom, white 70%, transparent 100%)`,
          maskImage: `linear-gradient(to bottom, white 70%, transparent 100%)`,
        }}
        {...props}
      />

      <div
        className={cn('relative px-fluid-4 bottom-0', {
          'pt-fluid-28 pb-fluid-8 -mb-fluid-4': hasBannerImage,
          'pt-fluid-8 pb-fluid-8': !hasBannerImage,
        })}
      >
        <div className="flex flex-col items-center space-y-fluid-4">
          <HeaderLogo
            media={page?.logoMedia}
            {...props}
            className="mb-fluid-6! rounded-full shadow-xl"
            sizeClassName="size-fluid-48"
            size={192}
          />

          <HeaderName
            name={page?.name}
            {...props}
            className={cn('text-fluid-4xl text-center', textClasses)}
          />

          <HeaderDescription
            description={page?.description}
            {...props}
            className={cn('text-fluid-lg text-center', textClasses)}
          />

          <HeaderSocialIcons
            socialIcons={page?.socialIcons}
            {...props}
            className="mt-fluid-6! w-full justify-center"
            primaryClassName="p-fluid-4 page-header-primary-button flex-1"
            secondaryClassName="p-fluid-4 page-header-secondary-button"
            showPrimaryLabel
          />
        </div>
      </div>
    </div>
  )
}
